js_wine_collection()
function js_wine_collection(){
    document.addEventListener('DOMContentLoaded', initWineCollection)
}

// inicializar wine coleccion
function initWineCollection() {
    const contents = document.querySelectorAll('.js-wine-collection')
    if (contents != null) {
        init()
    }
    
    function init(){
        
        for (let i = 0; i < contents.length; i++) {
            if (contents[i].dataset.tag == localStorage.wine_3) {
                contents[i].classList.remove('d-none')
                contents[i].classList.add('d-block')
            }
        }
    }
}
